const web = JSON.parse(window.localStorage.translations)
const translationText = {
  no_access: web.pages['setting-roles']['access-types_inputs']['net-dostupa'],
  view: web.pages['setting-roles']['access-types_inputs']['prosmotr'],
  edit: web.pages['setting-roles']['access-types_inputs']['redaktirovanie'],
  add: web.pages['setting-roles']['access-types_inputs']['dobavlenie'],
  delete: web.pages['setting-roles']['access-types_inputs']['udalenie'],
  block: web.pages['setting-roles']['access-types_inputs']['blokirovka'],
}
const paramsList = () => {
  // console.log('paramsList start', new Date())
  for (let itemKey in list) {
    let item = list[itemKey]
    for (let paramsKey in item.params) {
      let param = item.params[paramsKey]
      param.list = []
      if (param.accesses.view && Array.isArray(param.accesses.view)) {
        param.list.push(
          ...[
            {
              text: translationText.no_access,
              value: [],
            },
            {
              text: translationText.view,
              value: [...param.accesses.view],
            },
          ],
        )
      } else if (param.accesses.view === false || typeof param.accesses.view === 'string') {
        param.list.push(
          ...[
            {
              text: translationText.no_access,
              value: [],
            },
          ],
        )
      } else {
        param.list.push(
          ...[
            {
              text: translationText.view,
              value: [],
            },
          ],
        )
      }
      if (
        param.accesses.edit ||
        param.accesses.add ||
        param.accesses.remove ||
        param.accesses.block
      ) {
        let data = {
          text:
            translationText.view +
            (param.accesses.edit ? ', ' + translationText.edit : '') +
            (param.accesses.add ? ', ' + translationText.add : '') +
            (param.accesses.remove ? ', ' + translationText.delete : '') +
            (param.accesses.block ? ', ' + translationText.block : ''),
          value: [],
        }
        if (Array.isArray(param.accesses.view)) {
          data.value.push(...param.accesses.view)
        }
        if (Array.isArray(param.accesses.edit)) {
          data.value.push(...param.accesses.edit)
        }
        if (Array.isArray(param.accesses.add)) {
          data.value.push(...param.accesses.add)
        }
        if (Array.isArray(param.accesses.remove)) {
          data.value.push(...param.accesses.remove)
        }
        if (Array.isArray(param.accesses.block)) {
          data.value.push(...param.accesses.block)
        }
        param.list.push(...[data])
      }
    }
  }
  // console.log('paramsList end', new Date())
}
const list = {
  planning: {
    title: web.pages['setting-roles']['access-types_planning']['planirovanie'],
    params: [
      {
        name: web.pages.planning.pages['obem-zakazov'],
        accesses: { view: ['view_orders_volume'] },
      },
      {
        name: web.pages.planning.pages['obshchiy-grafik'],
        accesses: { view: ['view_general_schedule'] },
      },
    ],
  },
  sales: {
    title: web.pages['setting-roles']['access-types_sales']['prodazhi'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: {
          view: ['view_sales'],
          edit: ['edit_sales'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-roles']['access-types_sales']['dostup'],
        accesses: {
          view: [
            'view_client_project',
            'view_scheme_types',
            'view_scheme_classes',
            'view_document_types',
            'view_work_areas',
            'view_project_documents',
            'view_project_schemes',
            'view_project_work_types',
            'view_project_work_type_periods',
            'view_project_responsible',
          ],
          edit: [
            'edit_client_project',
            'edit_scheme_types',
            'edit_scheme_classes',
            'edit_document_types',
            'edit_work_areas',
            'edit_project_documents',
            'edit_project_schemes',
            'edit_project_work_types',
            'edit_project_work_type_periods',
            'edit_project_responsible',
          ],
          add: 'edit',
          remove: 'edit',
        },
      },
    ],
  },
  projects: {
    title: web.pages.pages.buttons.proekty,
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: {
          view: ['view_projects'],
          edit: ['edit_projects'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-roles']['access-types_sales']['view_all_project'],
        accesses: {
          view: ['view_all_client_project', 'view_project_subscribers', 'edit_project_subscribers'],
        },
      },
      {
        name: web.pages.projects.pages.project_reports,
        accesses: {
          remove: ['delete_period_reports'],
        },
      },
      {
        name: web.pages.projects.pages.reports,
        accesses: {
          view: ['view_project_reports'],
        },
      },
      {
        name: web.pages.projects.reports_table.invoice,
        accesses: { view: ['view_bills'] },
      },
    ],
  },
  statistics: {
    title: web.pages.projects.pages.statistics,
    params: [
      {
        name: web.pages.personnel_department.pages.sotrudniki,
        accesses: { edit: ['edit_work_days'], add: 'edit', remove: 'edit' },
      },
    ],
  },
  hr: {
    title: web.pages.pages.buttons['otdel-kadrov'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: { view: ['view_hr'], edit: ['edit_hr'], add: 'edit', remove: 'edit' },
      },
      {
        name: web.pages['setting-roles']['access-types_employees']['sotrudniki'],
        accesses: {
          view: ['view_employees'],
          edit: ['edit_employees', 'add_employees', 'remove_employees'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-roles']['access-types_employees']['dolzhnosti-tipy-rabot'],
        accesses: {
          view: ['view_work_roles', 'view_employee_work_types'],
          edit: ['edit_work_roles', 'edit_employee_work_types'],
          add: 'edit',
          remove: 'edit',
        },
      },
    ],
  },
  clients: {
    title: web.pages['setting-roles']['access-types_setting']['klienty'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: {
          view: ['view_clients'],
          edit: ['edit_clients', 'edit_invoicing_companies'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-client']['address']['adresa'],
        accesses: {
          view: ['view_client_addresses'],
          edit: ['edit_client_addresses'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-client']['contacts']['kontakty'],
        accesses: {
          view: ['view_client_contacts'],
          edit: ['edit_client_contacts'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-client']['persons']['kontaktnye-litsa'],
        accesses: {
          view: ['view_client_people'],
          edit: ['edit_client_people'],
          add: 'edit',
          remove: 'edit',
        },
      },
    ],
  },
  finance: {
    title: web.pages.pages.buttons['finance'],
    params: [
      {
        name: web.pages.finance.pages.salary,
        accesses: { view: ['view_salary'], edit: ['edit_salary'], add: 'edit', remove: 'edit' },
      },
      {
        name: web.pages.finance.pages.invoice,
        accesses: {
          view: ['view_invoices'],
          edit: ['edit_invoices'],
        },
      },
    ],
  },
  //interface: {
  //   title: web.pages.setting.pages['administrirovanie-interfeysa'],
  //   params: [
  //     {
  //       name: web.pages['setting-roles']['access-types_planning'][
  //         'nalichie-dostupa'
  //       ],
  //       accesses: {view: ['view_interface'], edit: ['edit_interface']},
  //     },
  //   ],
  // },
  //timeControl: {
  //   title:
  //     web.pages['setting-roles']['access-types_time-control'][
  //       'kontrol-rabochego-vremeni'
  //     ],
  //   params: [
  //     {
  //       name: web.pages['setting-roles'][
  //         'access-types_time-control'
  //       ]['nalichie-dostupa'],
  //       accesses: {view: ['employee_time_control']},
  //     },
  //   ],
  // },
  freeDocuments: {
    title: web.pages.setting.pages['free_documents'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: {
          view: ['view_free_documents'],
          edit: ['edit_free_documents'],
          add: 'edit',
          remove: 'edit',
        },
      },
    ],
  },
  roles: {
    title: web.pages['setting-roles']['access-types_setting']['roli'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_setting']['nastroyki'],
        accesses: {
          view: ['view_roles'],
          edit: ['add_roles', 'edit_roles', 'remove_roles'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['setting-users']['dialog-assign_role-buttons']['naznachit-rol'],
        accesses: {
          view: 'edit',
          edit: ['assign_user_roles', 'remove_user_roles'],
        },
      },
    ],
  },
  setting: {
    title: web.pages['setting-roles']['access-types_setting']['nastroyki'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_setting']['polzovateli'],
        accesses: {
          view: ['view_users'],
          edit: ['edit_users', 'add_users', 'remove_users', 'block_users'],
          add: 'edit',
          remove: 'edit',
          block: 'edit',
        },
      },
      {
        name: web.pages['setting-roles']['access-types_setting'][
          'segmenty-vida-deyatelnosti-tipy-proektov-kategorii-rabot-vidy-rabot-vidy-dopolnitelnyh-rabot-regiony'
        ],
        accesses: {
          view: [
            'view_work_type',
            'view_business_segments',
            'view_project_types',
            'view_regions',
            'view_work_extra_types',
          ],
          edit: [
            'add_work_type',
            'edit_work_type',
            'remove_work_type',
            'edit_business_segments',
            'edit_project_types',
            'edit_regions',
            'edit_work_extra_types',
          ],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages['sales_project']['price_offer_terms-labels'].templates,
        accesses: {
          view: 'edit',
          edit: ['edit_default_content_settings'],
        },
      },
    ],
  },
  personalArea: {
    title: web.pages['setting-roles']['access-types_personal-area']['lichnyy-kabinet'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_personal-area']['sluzhebnye-dannye'],
        accesses: { view: ['view_employees_service_data'] },
      },
      {
        name: web.pages['setting-roles']['access-types_personal-area']['kontrakty'],
        accesses: {
          edit: ['edit_employees_contract', 'add_employees_contract', 'remove_employees_contract'],
          add: 'edit',
          remove: 'edit',
        },
      },
      {
        name: web.pages.finance.pages.salary,
        accesses: { view: true, edit: ['edit_employee_salary'] },
      },
    ],
  },
  pushes: {
    title: web.pages.setting.pages['push_notifications'],
    params: [
      {
        name: web.pages['setting-roles']['access-types_planning']['nalichie-dostupa'],
        accesses: {
          view: ['view_notifications'],
          edit: ['edit_notifications'],
          add: 'edit',
          remove: 'edit',
        },
      },
    ],
  },
  companySettings: {
    title: web.pages.setting.pages['setting_company'],
    params: [
      {
        name: web.pages['setting-setting_company'].all['main'],
        accesses: {
          view: 'edit',
          edit: ['edit_general_settings'],
        },
      },
      {
        name: web.pages['setting-setting_company'].all['geoposition'],
        accesses: {
          view: 'edit',
          edit: ['edit_geo_position_settings'],
        },
      },
      {
        name: web.pages['setting-setting_company'].all['start_stop'],
        accesses: {
          view: 'edit',
          edit: ['edit_start_stop_settings'],
        },
      },
      {
        name: web.pages['setting-setting_company'].all['mobile_calendar'],
        accesses: {
          view: 'edit',
          edit: ['edit_mobile_calendar_settings'],
        },
      },
      {
        name: web.pages['setting-setting_company'].all['fin-system'],
        accesses: {
          view: 'edit',
          edit: ['edit_financial_settings'],
        },
      },
    ],
  },
}
paramsList()

export default list
